import { Auth, TokenParsed } from './Auth';

const tokenData: TokenParsed = {
  name: 'Ola Nordmann',
  cmId: 'user-cm-id',
  signature: undefined,
  email: 'ola.nordmann@example.com',
  amr: 'bankid',

  behalfOf: {
    cmId: '99999999',
  },
};

async function initialize(): Promise<void> {
  return Promise.resolve();
}

function getToken(): Promise<string> {
  return Promise.resolve('<mocked token>');
}

function getTokenParsed(): TokenParsed {
  return tokenData;
}

function getStaleTokenParsed(): TokenParsed {
  return tokenData;
}

function logout(): void {
  // Nothing to do when doing testing.
}

function isAuthenticated(): boolean {
  return true;
}

export const mockExternalUserAuth: Auth = {
  initialize,
  getToken,
  getTokenParsed,
  getStaleTokenParsed,
  logout,
  isAuthenticated,
};
